// LoginPrompt.tsx
import { LogIn } from "lucide-react"

import { AuthShell } from "@/components/auth/AuthShell"

export default function LoginPrompt({ handleRedirect }: { handleRedirect: () => void }) {
  return (
    <AuthShell
      title="Login required"
      description="Please sign in with your Sagepoint Energy account to continue."
      primaryLabel="Login"
      onPrimaryClick={handleRedirect}
      primaryIcon={<LogIn className="h-4 w-4" />}
    />
  )
}
